module.exports = "/images/oculus-8.jpg";